/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core'
import InfoBox from '@components/Affiliate/InfoBox'
import InfoPanel from '@components/Affiliate/InfoPanel'
import ProfitsIcon from '@assets/images/png/profits.png'
import MoneyIcon from '@assets/images/png/money.png'
import WithdrawalIcon from '@assets/images/png/withdrawal.png'
import { ReactComponent as BrowserIcon } from '@assets/images/svg/browser-white.svg'
import { ReactComponent as CurrentAmount } from '@assets/images/svg/current_amount.svg'
import { ReactComponent as ReferralUrl } from '@assets/images/svg/referral_url.svg'
import { ReactComponent as MyReferral } from '@assets/images/svg/my_referral.svg'
import { resellerApiWithToken } from '@api/baseApi'

import Cookies from 'js-cookie'

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
  },
}))

export default function Informations() {
  const classes = useStyles()
  const [summary, setSummary] = useState({})
  const scope = Cookies.get('scope')

  let summaryPath

  if (scope === 'reseller') {
    summaryPath = '/resellers/summaries/'
  } else {
    summaryPath = '/affiliates/summaries/'
  }

  const getSummaries = async () => {
    try {
      const { status, data: { data } } = await resellerApiWithToken.get(summaryPath)
      if (status === 200) {
        setSummary(data)
      }
    } catch (error) {
      setSummary({})
    }
  }

  useEffect(() => {
    getSummaries()
  }, [])

  return (
    <div className={classes.root}>
      <div>
        <InfoBox
          title="Total Order"
          amount={summary?.order || 0}
          icon={<BrowserIcon />}
        />
        <InfoBox
          title="Total Komisi"
          amount={summary.formatted_commission || 0}
          icon={<img src={ProfitsIcon} alt="profits" />}
        />
      </div>
      <div>
        <InfoBox
          title="Total Transaksi Referral"
          amount={summary.formatted_transaction || 0}
          icon={<img src={MoneyIcon} alt="profits" />}
        />
        <InfoBox
          title="Total Withdrawal"
          amount={summary.formatted_withdraw || 0}
          icon={<img src={WithdrawalIcon} alt="profits" />}
        />
      </div>
      <div>
        <InfoPanel
          title="Saldo Saat Ini"
          amount={summary?.balance ? summary.formatted_balance : 'Rp. 0'}
          backgroundPrimary="#37FF60"
          backgroundSecondary="#00FF34"
          icon={<CurrentAmount />}
        />
        <InfoPanel
          title="Referral URL"
          text={summary?.referral_url || '-'}
          backgroundPrimary="#FFAD38"
          backgroundSecondary="#FF9600"
          icon={<ReferralUrl />}
        />
        <InfoPanel
          title="Kode Referral Saya"
          text={summary?.referral_code || '-'}
          backgroundPrimary="#37AFFF"
          backgroundSecondary="#0099FF"
          icon={<MyReferral />}
        />
      </div>
    </div>
  )
}
